import { http } from "./http";
import { notification } from "antd";

export const postEmailInvitationInterprete = async userId => {
  const response = await http.get(`users/email/${userId}`);

  return response.data;
};

export const doesThisEmailExist = async email => {
  const response = await http.get(`users/byemail/${email}`);

  return response.data?.user;
};

export const getUserByToken = async token => {
  const response = await http.get(`users/token/${token}`);

  return response.data;
};

export const resetPassword = async data => {
  let send = await http.post("/notifications/lost", data);

  return send.data;
};

export const sendEmailInvitation = async (userId) => {
  let caller = await http.post("/notifications/invitation", {
    userId: userId,
  });
  caller.status === 200 &&
    notification.success({
      message: `Email envoyé avec succès`,
    });
};
